export default "__VITE_ASSET__1aec031f__"